<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import { resumeOnboarding, cancelOnboarding } from "$app/utils"
  import Recognitions from "./Recognitions.svelte"
  import Onboarding from "$app/Pages/Plans/OnePageView/Onboarding.svelte"
  import { appStore } from "$app/store.svelte"

  interface Props {
    plan: PlanType
    users: UserType[]
    external_recipients: ExternalRecipientType[]
    user_stats: any
    plan_review: any
    params: any
    dates: any
    onboarding: any
  }

  let props = $props()
  let {
    plan,
    users,
    external_recipients,
    user_stats,
    plan_review,
    dates,
    onboarding
  }: Props = props

  appStore.onboarding = onboarding
  appStore.users = Object.values(users).map((k, v) => k)
  appStore.external_recipients = external_recipients
  appStore.plan_review = plan_review
  appStore.dates = dates

  let mode = $state("list")
</script>

<Layout {...props}>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 pb-8">
    {#if onboarding.completed_onboarding}
      <div class="mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div class="grid grid-cols-4 gap-4 items-center py-2 mb-2">
          <div class="col-span-2 sm:col-span-3 flex items-center">
            <h1 class="text-xl md:text-2xl lg:text-3xl">
              Building Our Culture and Practicing Gratefulness
            </h1>
          </div>
          <div class="col-span-2 sm:col-span-1 flex items-center justify-end">
            <div
              class="flex items-center text-sm rounded-md border border-gray-300"
            >
              <button
                type="button"
                onclick={() => (mode = "list")}
                class={[
                  "px-4 py-2 rounded-md rounded-r-none border-r border-gray-300",
                  mode === "list" ? "bg-white" : ""
                ]}
              >
                List
              </button>
              <button
                type="button"
                onclick={() => (mode = "slideshow")}
                class={[
                  "px-4 py-2 rounded-md rounded-l-none border",
                  mode === "slideshow" ? "bg-white" : ""
                ]}
              >
                Slideshow
              </button>
            </div>
          </div>
        </div>

        <Recognitions plan_id={plan.id} {user_stats} {mode} />
      </div>
    {:else}
      <Onboarding
        on:resume={() => resumeOnboarding(plan.id)}
        on:cancel={() => cancelOnboarding(plan.id)}
      />

      <div class="bg-white overflow-hidden shadow">
        <div class="px-4 py-8 sm:px-6 relative">
          <h2
            class="text-2xl text-center text-gray-800 flex justify-center items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 mr-1"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
              />
            </svg>

            Recognitions
          </h2>

          <p class="text-lg text-center mt-6 text-gray-700">
            The Recognitions page will be available once you have completed the
            setup process.
          </p>
        </div>
      </div>
    {/if}
  </div>
</Layout>

<style lang="postcss">
  .selected {
    color: var(--core);
    outline: 2px solid var(--indigo-400);
    background-color: var(--indigo-600);
  }
</style>
